import http from "../http-common";
import authHeader from "./authHeader";
import { CUSTOMER_API } from "../api";
const getAllCustomers = () => {
  return http.get(`${CUSTOMER_API}`, { headers: authHeader() });
};

const getCustomerById = (id) => {
  return http.get(`${CUSTOMER_API}/${id}`, { headers: authHeader() });
};

const createCustomer = (data) => {
  return http.post(`${CUSTOMER_API}`, data, { headers: authHeader(), "Content-Type": "multipart/form-data" });
};
const resignCustomer = (id) => {
  return http.put(`${CUSTOMER_API}/${id}`, { role: null }, { headers: authHeader() });
};

const assignCustomer = (id, role) => {
  return http.put(`${CUSTOMER_API}/${id}`, { role }, { headers: authHeader() });
};
const updateCustomer = (id, data) => {
  return http.put(`${CUSTOMER_API}/${id}`, data, { headers: authHeader(), "Content-Type": "multipart/form-data" });
};
const updateCustomerFormDraft = (id, data) => {
  return http.put(`${CUSTOMER_API}/${id}/draft`, data, { headers: authHeader() });
};

const removeCustomer = (id) => {
  return http.delete(`${CUSTOMER_API}/${id}`, { headers: authHeader() });
};

const CustomerService = {
  getAllCustomers,
  getCustomerById,
  createCustomer,
  updateCustomer,
  removeCustomer,
  resignCustomer,
  assignCustomer,
  updateCustomerFormDraft,
};

export default CustomerService;
